// This file maps state to stores
import TemplateStore from '@src/stores/TemplateStore';
import CommonStore from '@src/stores/CommonStore';
import GraphStore from '@src/stores/GraphStore';
import ActionStore from '@src/ActionStore';

/**
 * These are the stores the container will subscribe to, the getStateFromStores()
 * below runs again if the stores mentioned here emit a change
 * @type {Array}
 */
export const listenToStores = [
  TemplateStore,
  CommonStore,
  ActionStore,
  GraphStore,
];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    subStories: GraphStore.getGraph() || [],
    templateData: TemplateStore.getTemplateData(),
    metatags: CommonStore.getMetaTags(),
  };
}

export {
  fetchTemplateData,
  addTemplateToStory,
  addGeneralNodeTemplateToBot,
  updateTemplateData,
} from 'actions/TemplateActions';
export { updateComponentModal } from 'actions/BotActions';
